import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "rcornersgrey mx-auto vstack",
  style: {"max-width":"800px","overflow":"initial"}
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "required",
  for: "txtNewPassword"
}, " Password ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "required",
  for: "txtConfirmNewPassword"
}, " Confirm Password ", -1)
const _hoisted_6 = {
  id: "buttonWrap",
  class: "mt-4"
}
const _hoisted_7 = {
  key: 0,
  href: "signin.aspx"
}

import { useUserStore } from '@/stores/userStore';
import { info } from 'sass';
import { computed, ref, watch, PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  props: {
    title: {},
    resetCode: {},
    user: {}
  },
  emits: ['submit'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const newPassword = ref("");
const confirmPassword = ref("");
const showAlert = ref(false);
const alertText = ref("");
const alertType = ref("error");
const emits = __emit;
const userStore = useUserStore();
const resetComplete = ref(false);

userStore.validateResetCode(props.user, props.resetCode)?.then((result)=> {
    
    if(typeof(result) === "boolean" && result == false ){
        SetAlertInfo("error", "The link that was used to access this page has expired. Please try resetting your password again.");
    }
 });

function handleSubmitClick() {
    validateInputs(()=> {
        
        if(!showAlert.value){
            userStore.postPasswordChangeInformation(props.user, newPassword.value, props.resetCode)?.then((result)=> {
console.log("Post Change Info Result :",result);
                if(result && result.data == true ){
                    SetAlertInfo("success", "Password change complete");
                    resetComplete.value = true;
                }
                else {
                    SetAlertInfo("error", "An error was encountered while trying to change your password. Please try again or contact your administrator.");
                    resetComplete.value = false;
                }
            
            });
        }
    });
}

function validateInputs(callback: () => void) {    
        if(newPassword.value != confirmPassword.value){
            alertText.value = "New password and confirm password values must match!";
            showAlert.value = true;
            callback();
        }
        else {
            userStore.validateNewPassword(props.user, newPassword.value).then((data: string[]) => {                
                showAlert.value = true;                
                
                if(data != undefined && data.length > 0){
                    let validationMessages = "";

                    if(data.length === 1){
                        validationMessages = data[0];
                    }
                    else{
                        data.forEach(message => {
                            if(message){
                                validationMessages += `- ${message}`;
                            }
                        });
                    }
                    
                    alertText.value = validationMessages;
                    showAlert.value = true;
                }
                else {
                    showAlert.value = false;
                }

                callback();
            });
        }    
}

function SetAlertInfo(type:string, text: string){
    alertType.value = type;
    alertText.value = text;
    showAlert.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        type: "password",
        id: "txtNewPassword",
        class: "form-control mb-2",
        required: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event))
      }, null, 512), [
        [_vModelText, newPassword.value]
      ]),
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        type: "password",
        id: "txtConfirmNewPassword",
        class: "form-control",
        required: "",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmPassword).value = $event))
      }, null, 512), [
        [_vModelText, confirmPassword.value]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-lg btn-primary",
          type: "button",
          "aria-label": "submit button",
          onClick: _withModifiers(handleSubmitClick, ["prevent"])
        }, "Submit")
      ]),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([{'alert-danger':alertType.value == 'error', 'alert-success':alertType.value == 'success'}, "alert mt-1"]),
        role: "alert"
      }, _toDisplayString(alertText.value), 3), [
        [_vShow, showAlert.value]
      ]),
      (resetComplete.value)
        ? (_openBlock(), _createElementBlock("a", _hoisted_7, "Return to sign in page"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})